import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  content?: JSX.Element
  disabled: boolean
}

export const AcceptPartnerModal = ({ open, onClose, onSubmit, content, disabled }: Props) => {
  const { t } = useTranslation()

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`w-full flex flex-col gap-y-8 max-w-xl transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative`}
              >
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>
                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {t('event.acceptPartner')}
                </Dialog.Title>

                {content}

                <div className="flex justify-center gap-x-6">
                  <button
                    onClick={onSubmit}
                    disabled={disabled}
                    className={`${
                      disabled
                        ? 'bg-slate-300 text-white'
                        : 'bg-navy-900 hover:bg-opacity-20 bg-opacity-10 text-navy-900'
                    } py-1 w-24 rounded  font-semibold`}
                  >
                    {t('event.register')}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
